<template>
  <div>
    <eisart-layout
      v-bind:nav_items="nav_items"
      v-bind:init_index="activeIndex"
      v-on:site-index="onSiteIndexEvent"
    >
      <template v-if="activeIndex===1">
        <start-view />
      </template>
      <template v-if="activeIndex===2">
        <ice-ice-baby />
      </template>
      <template v-else-if="activeIndex===3">
        <impressum-view/>
      </template>
      <template v-else-if="activeIndex===4">
        <datenschutz-view />
      </template>
    </eisart-layout>
  </div>
</template>

<script>
import EisartLayout from "./eisart-layout.vue";
import StartView from './start.vue';
import SortimentView from "./sortiment.vue";
import ImpressumView from "./impressum.vue";
import DatenschutzView from "./datenschutz.vue";
import IceIceBaby from "./iceicebaby.vue"

export default {
  name: "MainView",
  data() {
    return {
      activeIndex: 1,
      nav_items: [
        { idx: 1, message: "Startseite" },
        { idx: 2, message: "Catering" },
        { idx: 3, message: "Impressum" },
        { idx: 4, message: "Datenschutz" }
      ]
    };
  },
  components: {
    EisartLayout,
    StartView,
    SortimentView,
    ImpressumView,
    DatenschutzView,
    IceIceBaby
  },

  methods: {
    onSiteIndexEvent: function(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/eisart/eisart-main.vue